import { isIOS } from "react-device-detect";
import callAPI from "../api";

export const generatePlaceholder = (length, character = "_") => {
  if (typeof character !== "string" || character.length !== 1) {
    throw new Error("Character must be a single string character.");
  }

  if (typeof length !== "number" || length < 0) {
    throw new Error("Length must be a non-negative number.");
  }

  return character.repeat(length);
};

export const getOtpLength = (config, carrierCode) => {
  if (!config?.otp_length) {
    console.warn("Invalid config object passed to getOtpLength");
    return 4;
  }

  const specificLength = config.otp_length[carrierCode];
  if (specificLength) {
    return specificLength;
  }

  return config.otp_length["*"] ?? 4;
};

export const cleanMessage = (message) => {
  if (!message) return "";
  return message
    .split("_")
    .join(" ")
    .toLowerCase()
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
};

const listentoSubscription = (ref_id, session_id) => {
  return callAPI(
    {
      token: ref_id,
      session_id: session_id,
    },
    "listenSubscription"
  )
    .then((data) => {
      if (data.status === "success") {
        window.location.href = data.payload.redirect_link;
      } else {
        setTimeout(() => {
          listentoSubscription(ref_id, session_id);
        }, 5000);
      }
    })
    .catch((e) => console.log("ListenSubscription Error ", e));
};

const prepareAndInitSMS = (short_code, keyword) => {
  const smsCommand = isIOS
    ? `sms://open?addresses=${short_code};?&body=${keyword}`
    : `sms:${short_code};?&body=${keyword}`;
  window.location.assign(smsCommand);
};

const waitFor = async (milliseconds) =>
  new Promise((resolve) =>
    setTimeout(() => {
      resolve();
    }, milliseconds || 3000)
  );

export const handleApiReturn = async (
  config,
  payload,
  nextStep,
  handleVerificationRequest,
  handleCarrierCode
) => {
  if (payload.ref_id && typeof handleVerificationRequest === "function") {
    handleVerificationRequest(payload.ref_id);
    //console.log("Ref id: %s", data.payload.ref_id);
  }

  if (config.flow === "CLICK_2_SMS_REDIRECT") {
    const curKeyword = payload.keyword;

    nextStep();
    await waitFor(2000);
    prepareAndInitSMS(payload.short_code, curKeyword);
    listentoSubscription(payload.ref_id, payload.session_id);

    // await waitFor(3000);

    // nextStep();
  } else if (config.flow === "PIN_FLOW") {
    if (payload.carrier_code && typeof handleCarrierCode === "function") {
      if (!!handleCarrierCode) {
        handleCarrierCode(payload.carrier_code);
      }
    }
    nextStep();
  } else if (config.flow === "PREMIUM_CLICK_2_SMS") {
    nextStep();
  } else if(config.flow === "LOOKUP_2_SMS") {
    if (payload.keyword && config.open_sms_composer){
      prepareAndInitSMS(payload.short_code, payload.keyword);
    } else if(payload.redirect_url) {
      window.location.href = payload.redirect_url;
    }
  } else if (config.flow === "CELCOMDIGI_FLOW") {
    console.log("CELCOMDIGI_FLOW: Waiting 1 seconds before redirect to:", payload.redirect_url);
    setTimeout(() => {
      window.location.href = payload.redirect_url;
    }, 1000);
  } else {
    console.log("Flow is not configured: ", config.flow);
  }
};
